<div class="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4">
  <div class="max-w-xl mx-auto">
    @if (loading) {
      <div class="py-20 text-center text-gray-500 dark:text-gray-400">Cargando...</div>
    } @else if (done) {
      <div class="rounded-lg bg-white dark:bg-gray-800 shadow p-8 text-center space-y-3">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-success-100 text-success-600">
          <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
        </div>
        <h2 class="text-xl font-semibold text-gray-900 dark:text-white">{{ resultMessage }}</h2>
        @if (info && !info.cancelled) {
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Nueva fecha: {{ formatFecha(info.datetimeStart, info.timezone) }}
          </p>
        }
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Ya puedes cerrar esta ventana.
        </p>
      </div>
    } @else if (!info) {
      <div class="rounded-lg bg-white dark:bg-gray-800 shadow p-8 text-center space-y-3">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-error-100 text-error-600">
          <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </div>
        <p class="text-lg font-medium text-gray-900 dark:text-white">{{ error }}</p>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Si necesitas ayuda, responde al correo de la reunión y contacta al organizador.
        </p>
      </div>
    } @else {
      <div class="rounded-lg bg-white dark:bg-gray-800 shadow overflow-hidden">
        <div class="p-6 border-b border-gray-200 dark:border-gray-700">
          <h1 class="text-2xl font-bold text-gray-900 dark:text-white">{{ actionLabel }}</h1>
          <p class="mt-2 font-medium text-gray-900 dark:text-white">{{ info.title }}</p>
          <dl class="mt-3 space-y-1 text-sm text-gray-600 dark:text-gray-400">
            <div class="flex gap-2">
              <dt class="w-28 shrink-0 text-gray-500 dark:text-gray-500">Cuándo</dt>
              <dd>{{ formatFecha(info.datetimeStart, info.timezone) }}</dd>
            </div>
            <div class="flex gap-2">
              <dt class="w-28 shrink-0 text-gray-500 dark:text-gray-500">Dónde</dt>
              <dd>{{ modalidad }}</dd>
            </div>
            @if (info.organizerName) {
              <div class="flex gap-2">
                <dt class="w-28 shrink-0 text-gray-500 dark:text-gray-500">Organiza</dt>
                <dd>{{ info.organizerName }}@if (info.businessName) { <span class="text-gray-500"> · {{ info.businessName }}</span> }</dd>
              </div>
            }
          </dl>
        </div>

        <div class="p-6 space-y-4">
          @if (error) {
            <div class="rounded-lg border border-error-200 bg-error-50 p-3 dark:border-error-500/20 dark:bg-error-500/10">
              <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
              <button type="button" (click)="reintentar()"
                class="mt-2 text-xs font-medium text-error-700 underline dark:text-error-300">
                Actualizar los datos de la reunión
              </button>
            </div>
          }

          @if (info.cancelled) {
            <p class="text-sm text-gray-600 dark:text-gray-400">
              Esta reunión ya está cancelada. No hace falta que hagas nada más.
            </p>
          } @else if (info.actionType === 'cancel') {
            @if (info.canCancel) {
              <p class="text-sm text-gray-600 dark:text-gray-400">
                Vas a cancelar esta reunión. Puedes indicar un motivo (opcional):
              </p>
              <textarea [(ngModel)]="reasonText" rows="3" placeholder="Motivo de cancelación..."
                class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white"></textarea>
              <div class="flex justify-end gap-2">
                <button type="button" (click)="confirmCancel()" [disabled]="submitting"
                  class="px-5 py-2 rounded-lg bg-error-500 text-white text-sm font-medium hover:bg-error-600 disabled:opacity-50">
                  {{ submitting ? 'Cancelando...' : 'Cancelar reunión' }}
                </button>
              </div>
            } @else {
              <p class="text-sm text-gray-600 dark:text-gray-400">
                {{ info.blockedReason || 'Esta reunión ya no puede cancelarse desde aquí.' }}
              </p>
            }
          } @else if (info.actionType === 'reschedule') {
            @if (info.canReschedule) {
              <p class="text-sm text-gray-600 dark:text-gray-400">
                Elige una nueva fecha y hora (en tu zona horaria):
              </p>
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Nueva fecha</label>
                  <!-- INC 79: no se puede reprogramar al pasado (la hora se valida al enviar). -->
                  <input type="date" [(ngModel)]="newDate" [min]="minDate"
                    (click)="$any($event.target).showPicker?.()"
                    (focus)="$any($event.target).showPicker?.()"
                    class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white dark:[color-scheme:dark] cursor-pointer">
                </div>
                <div>
                  <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Nueva hora</label>
                  <input type="time" [(ngModel)]="newTime"
                    class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white">
                </div>
              </div>
              @if (info.maxReschedules) {
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  Reprogramaciones usadas: {{ info.rescheduleCount || 0 }} de {{ info.maxReschedules }}.
                </p>
              }
              <div class="flex justify-end gap-2">
                <button type="button" (click)="confirmReschedule()"
                  [disabled]="submitting || !newDate || !newTime"
                  class="px-5 py-2 rounded-lg bg-brand-500 text-white text-sm font-medium hover:bg-brand-600 disabled:opacity-50">
                  {{ submitting ? 'Guardando...' : 'Reprogramar' }}
                </button>
              </div>
            } @else {
              <p class="text-sm text-gray-600 dark:text-gray-400">
                {{ info.blockedReason || 'Esta reunión ya no puede reprogramarse desde aquí.' }}
              </p>
            }
          } @else {
            <p class="text-sm text-gray-600 dark:text-gray-400">
              Gracias por confirmar. Te esperamos en la reunión.
            </p>
          }
        </div>
      </div>
    }
  </div>
</div>
